var keyMirror = require('keymirror');

module.exports = keyMirror({
    EDIT_PORTFOLIO: null,
    UPLOAD_PORTFOLIO_IMAGE: null
});